import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '@spartacus/core';
import {DefaultModalComponent} from './default-modal/default-modal.component';
import {DefaultModalContainerComponent} from './default-modal-container/default-modal-container.component';
import {JoinClassesDirective} from '@app/directives/commons/join-classes.directive';

@NgModule({
  declarations: [
    DefaultModalComponent,
    DefaultModalContainerComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    JoinClassesDirective
  ],
  exports: [
    DefaultModalComponent,
    DefaultModalContainerComponent,
  ],
  providers: [
    DefaultModalComponent,
    DefaultModalContainerComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class DefaultModalModule {
}
